type CartQtyItem = {qty: number};

/** Sum of line quantities. Empty or missing collections are 0. */
export function getCartItemTotal(items?: CartQtyItem[] | null): number {
    if (!items?.length) {
        return 0;
    }
    return items.reduce((sum, item) => sum + (item.qty || 0), 0);
}

/** Singular only for exactly 1. Zero and other counts use "items". */
export function cartItemNoun(count: number): string {
    return count === 1 ? 'item' : 'items';
}

export function formatCartItemCount(count: number): string {
    return `${count} ${cartItemNoun(count)}`;
}
